import { useParams } from 'react-router-dom';

export function useNumberParam(key: string) {
  const { [key]: valueStr } = useParams();
  return Number(valueStr);
}